import React, { createContext, useContext, useState } from "react";

// Create the context
const ScheduleContext = createContext();

// Provider component
export const ScheduleContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(1);

  return (
    <ScheduleContext.Provider
      value={{
        open,
        setOpen,
        tab,
        setTab,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

// Hook to use the context
export const useScheduleContext = () => {
  const context = useContext(ScheduleContext);
  if (!context) {
    throw new Error(
      "useScheduleContext must be used within a ScheduleContextProvider",
    );
  }
  return context;
};
